module.exports = __webpack_public_path__ + "static/img/noData.aa501a5f.png";